(function () {
    'use strict';
    $(document).ready(function () {

        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        lightbox.option({
            'albumLabel': "Zdjęcie %1 z %2",
            'alwaysShowNavOnTouchDevices': true,
        })

        // Smooth scroll to
        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();

            const href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top
                }, 1000);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        //Search trigger
        $('.search-trigger').click(function () {
            $(this).toggleClass('active');
            $('.search-panel').fadeToggle('active');
            return false;
        });

        //Newsletter popup

        if ($('.fhp-popup').length) {

            var newsletterShowBySeconds = $('.fhp-popup').data('nwslttr-scnds');
            var newsletterShowByClicks = $('.fhp-popup').data('nwslttr-clks');
            var newsletterShowDays = $('.fhp-popup').data('nwslttr-ds');

            function showNewsletterPopup() {
                if (!getCookie('nwslttr')) {
                    $('.fhp-popup').fadeIn({
                        start: function () {
                            $(this).css({
                                display: "flex"
                            })
                        }
                    });
                    if (newsletterShowDays) {
                        setCookie('nwslttr', '1', newsletterShowDays);
                    }
                }
            }

            var newsletterClicks = 0;

            if (newsletterShowByClicks) {
                $(document).on('click', function() {
                    newsletterClicks++;

                    if (newsletterClicks == newsletterShowByClicks) {
                        showNewsletterPopup();
                    }
                });
            }

            if (newsletterShowBySeconds) {
                setTimeout(function() {
                    showNewsletterPopup();
                }, newsletterShowBySeconds);
            }

            $('.fhp-popup .fhp-popup-close').on('click', function() {
                $('.fhp-popup').fadeOut();
            });

        }

        //Clicked outside of element
        window.clickedOutside = function (targetToClose, callback, _excludes = []) {
            const excludes = Array.isArray(_excludes) ? _excludes : [_excludes];
            const $target = $(targetToClose);

            if (typeof callback !== "function") {
                console.error('Callback has to be a function!');
                return null;
            }

            $('body').on('click', function (e) {
                const clickedElement = e.target;
                const isTargetVisible = $target.css('display') !== 'none';
                const isClickedElementExcluded = excludes.some((exclusion) => $(exclusion).is(clickedElement) || !!$(exclusion).has(clickedElement).length);
                const isClickedElementTarget = $target.is(clickedElement);
                const isClickedElementATargetChild = $target.has(clickedElement).length === 0;

                if (
                    isTargetVisible &&
                    !isClickedElementExcluded &&
                    !isClickedElementTarget &&
                    isClickedElementATargetChild
                ) {
                    callback($target, excludes);
                }
            });
        }

        if (window.matchMedia("(min-width: 768px)").matches) {
            ScrollTrigger.create({
                trigger: ".col-content",
                pin: ".aside-menu",
                start: "top top",
                end: "bottom " + ($('.aside-menu').height()) + "px",
                onEnter: () => gsap.to(".aside-menu", {
                    css: {marginTop: 30},
                    delay: 0,
                    duration: .5,
                }),
                onEnterBack: () => gsap.to(".aside-menu", {
                    css: {marginTop: 0},
                    delay: 0,
                    duration: .5,
                }),
                onLeave: () => gsap.to(".aside-menu", {
                    css: {marginTop: 30},
                    delay: 0,
                    duration: .5,
                }),
                onLeaveBack: () => gsap.to(".aside-menu", {
                    css: {marginTop: 0},
                    delay: 0,
                    duration: .5,
                }),
            });
        }

        ScrollTrigger.create({
            trigger: '.header',
            start: "bottom top",
            endTrigger: "main",
            end: "bottom bottom",
            onEnter: () => gsap.to("#scroll-top", {
                autoAlpha: 1,
                delay: 0,
                duration: .5,
            }),
            onEnterBack: () => $('#scroll-top').removeClass('white'),

            onLeave: () => $('#scroll-top').addClass('white'),

            onLeaveBack: () => gsap.to("#scroll-top", {
                autoAlpha: 0,
                delay: 0,
                duration: .5,
            }),
        });
        if (window.matchMedia("(min-width: 768px)").matches) {
            ScrollTrigger.create({
                trigger: '.footer .support',
                start: "top bottom",
                onEnter: () => gsap.to(".header .support", {
                    autoAlpha: 0,
                    delay: 0,
                    duration: .5,
                }),
                onEnterBack: () => gsap.to(".header .support", {
                    autoAlpha: 1,
                    delay: 0,
                    duration: .5,
                }),
                onLeave: () => gsap.to(".header .support", {
                    autoAlpha: 0,
                    delay: 0,
                    duration: .5,
                }),
                onLeaveBack: () => gsap.to(".header .support", {
                    autoAlpha: 1,
                    delay: 0,
                    duration: .5,
                }),
            });
        }

        //Newsletter logic - BEGIN

        function sendNewsletterForm(formContext) {

            $.ajax({
                url: "/wp-admin/admin-ajax.php",
                method: "post",
                timeout: 10000,
                data: {
                    action: "newsletter_signup",
                    newsletter_user_email: $(formContext).closest('.newsletter-form').find('.newsletter-email').val(),
                },
                success: function (data) {
                    if (data == 'OK') {
                        $(formContext).closest('.newsletter-form').find('.ajax-success').slideDown();
                        $(formContext).closest('.newsletter-form').find(".newsletter-form").trigger("reset");
                    } else {
                        $(formContext).closest('.newsletter-form').find('.ajax-error').slideDown();
                    }
                },
                error: function (data) {
                    $(formContext).closest('.newsletter-form').find('.ajax-error').slideDown();
                },
                beforeSend: function () {
                    $(formContext).closest('.newsletter-form').find('.ajax-success').slideUp();
                    $(formContext).closest('.newsletter-form').find('.ajax-loading').slideDown();
                    $(formContext).closest('.newsletter-form').find('.ajax-error').slideUp();
                },
                complete: function () {
                    $(formContext).closest('.newsletter-form').find('.ajax-loading').slideUp();
                },
            });

        }

        $('.newsletter-signin').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.newsletter-form').find('.cf-error').hide();

            var isAllValid = true;

            if (validateEmail($(this).closest('.newsletter-form').find('.newsletter-email').val()) === false) {
                $(this).closest('.newsletter-form').find('.newsletter-email').siblings('.cf-error').slideDown();
                isAllValid = false;
            }

            if (!isAllValid) {
                return;
            }

            sendNewsletterForm(this);
        });

        function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        //Newsletter logic - END

        // Object fit IE11 polyfill
        objectFitImages();
    });
}(jQuery));
